import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    TOKEN_EXPIRED: {
        id: 'alert.token.expired',
        defaultMessage: 'Authorization token expired. Refresh?'
    },
    SATISFACTION_CHECK: {
        id: 'alert.info.ticket.satisfaction',
        defaultMessage: 'Has your question been answered?'
    },
    HDI_BE_UNREACHABLE: {
        id: 'alert.backend.unreachable.hdi',
        defaultMessage: 'Cannot reach HDI backend'
    },
    ADM_BE_UNREACHABLE: {
        id: 'alert.backend.unreachable.adm',
        defaultMessage: 'Cannot reach Administration backend'
    },
    HDI_WS_ERROR: {
        id: 'alert.error.ws.hdi',
        defaultMessage: 'Unexpected HDI WebSocket error'
    },
    ADM_WS_ERROR: {
        id: 'alert.error.ws.adm',
        defaultMessage: 'Unexpected Administration WebSocket error'
    },
    HDI_WS_STRUCT_ERROR: {
        id: 'alert.error.ws.structure.hdi',
        defaultMessage: 'Command structure error for HDI'
    },
    ADM_WS_STRUCT_ERROR: {
        id: 'alert.error.ws.structure.adm',
        defaultMessage: 'Command structure error for Administration'
    },
    FILE_DOWNLOAD_ERROR: {
        id: 'alert.error.file.download',
        defaultMessage: 'Cannot download file'
    },
    FILE_UPLOAD_ERROR: {
        id: 'alert.error.file.upload',
        defaultMessage: 'Cannot upload file'
    },
    RIGHTS_ADMIN_FETCH_ERROR: {
        id: 'alert.error.rights.admin.fetch',
        defaultMessage: 'Cannot fetch Rights Management admin data'
    },
    RIGHTS_ADMIN_RETRIEVED_ERROR: {
        id: 'alert.error.rights.admin.retrieved',
        defaultMessage: 'Retrieved invalid admin rights from backend'
    },
    RIGHTS_ADMIN_SEND_ERROR: {
        id: 'alert.error.rights.admin.send',
        defaultMessage: 'Cannot send invalid admin rights to backend'
    },
    RIGHTS_DEALER_FETCH_ERROR: {
        id: 'alert.error.rights.dealer.fetch',
        defaultMessage: 'Cannot fetch Rights Management dealer data'
    },
    RIGHTS_DEALER_RETRIEVED_ERROR: {
        id: 'alert.error.rights.dealer.retrieved',
        defaultMessage: 'Retrieved invalid dealer rights from backend'
    },
    RIGHTS_DEALER_SEND_ERROR: {
        id: 'alert.error.rights.dealer.send',
        defaultMessage: 'Cannot send invalid dealer rights to backend'
    },
    RIGHTS_EDITOR_FETCH_ERROR: {
        id: 'alert.error.rights.editor.fetch',
        defaultMessage: 'Cannot fetch Rights Management editor data'
    },
    RIGHTS_EDITOR_RETRIEVED_ERROR: {
        id: 'alert.error.rights.editor.retrieved',
        defaultMessage: 'Retrieved invalid editor rights from backend'
    },
    RIGHTS_EDITOR_SEND_ERROR: {
        id: 'alert.error.rights.editor.send',
        defaultMessage: 'Cannot send invalid editor rights to backend'
    },
    SOLUTION_GROUPS_DELETE_ERROR: {
        id: 'alert.error.solutions.groups.delete',
        defaultMessage: 'Cannot delete the Solution Group'
    },
    SOLUTION_GROUPS_FETCH_ERROR: {
        id: 'alert.error.solution.groups.fetch',
        defaultMessage: 'Cannot fetch all available Solution Groups'
    },
    SOLUTION_GROUPS_LIST_FETCH_ERROR: {
        id: 'alert.error.solution.groups.list.fetch',
        defaultMessage: 'Cannot fetch Solution Group list data'
    },
    SOLUTION_GROUPS_NEW_SAVE_ERROR: {
        id: 'alert.error.solution.groups.new.save',
        defaultMessage: 'Cannot save new Solution Group'
    },
    SOLUTION_GROUPS_NEW_SEND_ERROR: {
        id: 'alert.error.solution.groups.new.send',
        defaultMessage: 'Cannot send invalid new Solution Group to backend'
    },
    SOLUTION_GROUPS_RETRIEVED_ERROR: {
        id: 'alert.error.solution.groups.retrieved',
        defaultMessage: 'Retrieved invalid Solution Groups from backend'
    },
    SOLUTION_GROUPS_LIST_RETRIEVED_ERROR: {
        id: 'alert.error.solution.groups.list.retrieved',
        defaultMessage: 'Retrieved invalid Solution Groups list from backend'
    },
    SOLUTION_GROUPS_SAVE_ERROR: {
        id: 'alert.error.solution.groups.save',
        defaultMessage: 'Cannot save existing Solution Group'
    },
    SOLUTION_GROUPS_SEND_ERROR: {
        id: 'alert.error.solution.groups.send',
        defaultMessage: 'Cannot send invalid existing Solution Group to backend'
    },
    USERS_DETAILS_FETCH_ERROR: {
        id: 'alert.error.users.details.fetch',
        defaultMessage: "Cannot fetch user's detail"
    },
    USERS_FETCH_ERROR: {
        id: 'alert.error.users.fetch',
        defaultMessage: 'Cannot fetch users'
    },
    USERS_RETRIEVED_ERROR: {
        id: 'alert.error.users.retrieved',
        defaultMessage: 'Retrieved invalid user from backend'
    },
    USERS_SAVE_ERROR: {
        id: 'alert.error.users.save',
        defaultMessage: 'Cannot save a user'
    },
    DETAILS_FOR_SUPPORT: {
        id: 'alert.link.detailsForSupport',
        defaultMessage: 'Details for Support'
    },
    TICKET_NEW_SEND_ERROR: {
        id: 'alert.error.ticket.new.send',
        defaultMessage: 'Cannot send invalid new Ticket to backend'
    },
    TICKET_UPDATE_SEND_ERROR: {
        id: 'alert.error.ticket.update.send',
        defaultMessage: 'Cannot send invalid updated Ticket to backend'
    },
    TICKET_FETCH_SEND_ERROR: {
        id: 'alert.error.ticket.fetch.send',
        defaultMessage: 'Retrieved invalid ticket from backend'
    },
    BVM_LOAD_ERROR: {
        id: 'alert.error.bvm.load',
        defaultMessage: 'Could not load BVM data for the given VIN'
    },
    BVM_LOAD_TIMEOUT: {
        id: 'alert.error.bvm.timeout',
        defaultMessage: 'BVM did not respond in time, please try again'
    },
    BVM_VIN_NOT_FOUND: {
        id: 'alert.error.bvm.vin.notFound',
        defaultMessage: 'The given VIN was not found in BVM'
    },
    BVM_INVALID_VIN: {
        id: 'alert.error.bvm.vin.invalid',
        defaultMessage: 'BVM rejected the given VIN as invalid'
    },
    EDITOR_NEW_SEND_ERROR: {
        id: 'alert.error.editor.new.send',
        defaultMessage: 'Cannot send invalid new editor to backend'
    },
    EDITOR_UPDATE_SEND_ERROR: {
        id: 'alert.error.editor.update.send',
        defaultMessage: 'Cannot send invalid updated editor to backend'
    },
    EDITOR_FETCH_SEND_ERROR: {
        id: 'alert.error.editor.fetch.send',
        defaultMessage: 'Retrieved invalid editor from backend'
    },
    SOLUTION_GROUP_NEW_SEND_ERROR: {
        id: 'alert.error.solutionGroup.new.send',
        defaultMessage: 'Cannot send invalid new solution group to backend'
    },
    SOLUTION_GROUP_UPDATE_SEND_ERROR: {
        id: 'alert.error.solutionGroup.update.send',
        defaultMessage: 'Cannot send invalid updated solution group to backend'
    },
    SOLUTION_GROUP_FETCH_SEND_ERROR: {
        id: 'alert.error.solutionGroup.fetch.send',
        defaultMessage: 'Retrieved invalid solution group from backend'
    },
    TEMPLATE_NEW_SEND_ERROR: {
        id: 'alert.error.template.new.send',
        defaultMessage: 'Cannot send invalid new template to backend'
    },
    TEMPLATE_UPDATE_SEND_ERROR: {
        id: 'alert.error.template.update.send',
        defaultMessage: 'Cannot send invalid updated template to backend'
    },
    TEMPLATE_FETCH_SEND_ERROR: {
        id: 'alert.error.template.fetch.send',
        defaultMessage: 'Retrieved invalid template from backend'
    },
    TEMPLATE_MISSING_COUNTRY_ERROR: {
        id: 'alert.error.template.country.missing',
        defaultMessage: 'You must select country'
    },
});

export default messages;
